import { render, staticRenderFns } from "./FOSForm.vue?vue&type=template&id=88d29754&"
import script from "./FOSForm.vue?vue&type=script&lang=js&"
export * from "./FOSForm.vue?vue&type=script&lang=js&"
import style0 from "./FOSForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports